import React from "react";
import { ApplicationState } from "../../store";
import { connect, ConnectedProps } from "react-redux";
import { useTheme } from "@material-ui/core";
import { BrandsEnum } from "../../enums";
import { Theme } from "../../.themes";

export const ProfileName: React.FC<ProfileNameProps> = (props: ProfileNameProps) => {
  const theme: Theme = useTheme();

  if (theme.brand === BrandsEnum.NissanNo || theme.brand === BrandsEnum.VolviaNo) {
    const name = props.inputs.firstName + " " + props.inputs.lastName;
    return <>{name}</>;
  }
  const name = props.name + "!";

  if (!props.isCommercial && props.name?.indexOf(",") !== -1) {
    const parts = name?.split(",");
    parts?.push("!");
    if (parts?.length === 2) {
      return (
        <>
          {parts
            .map(i => i.trim())
            .reverse()
            .join(", ")}
        </>
      );
    }
  }
  return <>{name}</>;
};

const connector = connect(
  (state: ApplicationState) => ({ inputs: state.inputs, name: state.profile?.name, isCommercial: !!state.inputs?.orn }),
  {},
);

type ProfileNameProps = ConnectedProps<typeof connector>;

export default connector(ProfileName);
